import React, { useMemo } from 'react'
import { ButtonAddHLPure, ButtonHLPure, FilterHLPure, GridSelectionHLPure } from '../../pures'
import { Grid, useMediaQuery } from '@material-ui/core';
import { HeaderColumnOne, CellColumnOne, HeaderSemaforo, CellSemaforo } from '../../pures/gridSemaforo/gridSemaforo-cells';
import { useEffect } from 'react';
import { useState } from 'react';
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { Dialog } from '@progress/kendo-react-dialogs';
import RepseStatusByDocumentsView from "../repse-status-by-company/repse-status-by-documents.view"
import { ArrowBtnMobile } from '../../../assets/logos/icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const RepseStatusContractsView = (props) => {
    const {
        selectedContractor,
        contracts,
        getColorByContractStatus,
        onContractSelected,
        selectedContract,
        documents,
        getColorByDocumentStatus,
        selectedDocument,
        documentUrl,
        onDocumentSelected,
        yearFilterOptions,
        selectedYear,
        onBack,
        toggleContractDetailsScreen
    } = props;

    const showSwiper = useMediaQuery("(max-width:1000px)");

    const onYearFilterChange = (event) => {
        const selectedOption = event.target.value;
        props.onYearFilterChange(selectedOption);
    };

    // CONTRACTS GRID
    const [contractsDataGrid, setContractsDataGrid] = useState(contracts);
    const adjustScrollbar = contracts.length > 4;

    useEffect(() => {
        setContractsDataGrid(contracts);
        if (contracts && contracts.length > 0) {
            onContractSelected(contracts[0]);
        }
    }, [contracts])

    const onRowClickContract = (contract) => {
        onContractSelected(contract);
    }

    const CellColumnOneContracts = (props) => {
        console.log("props CellColumnOne sdfsfads", props)
        return <CellColumnOne {...props}
            onRowClick={onRowClickContract}
        />
    }

    const HeaderActionsCol = (props) => <span>{props.title}</span>

    const ActionsCell = (props) => {
        return <td className={props.dataItem.selected ? "selected" : ""}>
            <div className='RepseStatusView-company-gridActions'>
                <button className={showSwiper ? "mobileButton" : ""} onClick={() => toggleContractDetailsScreen(true, props.dataItem)}>
                    {showSwiper
                        ? <img
                            className="cellActions-icon-arrow"
                            alt={"cellActions-arrow"}
                            src={ArrowBtnMobile}
                        />
                        : "Ver detalle"
                    }
                </button>
            </div>
        </td>
    }

    const HeaderSemaforoContracts = () => {
        return <HeaderSemaforo showSwiper={showSwiper} swiperState={contractsSwiperState} />
    }

    const CellSemaforoContracts = (props) => {
        return (
            <CellSemaforo
                {...props}
                getColorByStatus={getColorByContractStatus}
                yearShown={selectedYear}
                showSwiper={showSwiper}
                swiperState={contractsSwiperState}
                onSlideChange={onContractSlideChange}
                onRowClick={onRowClickContract}
            />
        );
    }

    // DOCUMENTS GRID
    const [documentsDataGrid, setDocumentsDataGrid] = useState(documents);
    const [showDocumentDialog, setShowDocumentDialog] = useState(false);
    const pdfAws = useMemo(() => <PdfReader className="pdfReader" url={documentUrl} awsURL src={documentUrl}  ></PdfReader>, [documentUrl])

    useEffect(() => {
        setDocumentsDataGrid(documents);
    }, [documents])

    const onCloseDialog = () => setShowDocumentDialog(false);

    const [showBinnacle, setShowBinnacle] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState();
    const [selectedMonthNumber, setSelectedMonthNumber] = useState();

    // //Click on the month
    const onMonthSelected = (monthNumber, month) => {
        setSelectedMonth(month)
        setShowBinnacle(true)
        setSelectedMonthNumber(monthNumber)
    }

    const HeaderSemaforoDocuments = () => {
        return <HeaderSemaforo showSwiper={showSwiper} swiperState={documentsSwiperState}
            onHeaderRowClick={onMonthSelected}
        />
    }

    const CellSemaforoDocuments = (props) => {
        return (
            <CellSemaforo
                {...props}
                getColorByStatus={getColorByDocumentStatus}
                yearShown={selectedYear}
                showSwiper={showSwiper}
                swiperState={documentsSwiperState}
                onSlideChange={onDocumentSlideChange}
                onClick={onClickDocumentsSemaforo}
                clickableColors={["green", "yellow"]}
            />
        );
    }

    const onClickDocumentsSemaforo = async (dataItem, monthIndex) => {
        await onDocumentSelected(dataItem, monthIndex + 1);
        setShowDocumentDialog(true);
    }

    // SWIPERS
    const [contractsSwiperState, setContractsSwiperState] = useState({
        currSlide: 0,
        prevSlide: 0,
        touchedId: null,
        active: false,
    });
    const [documentsSwiperState, setDocumentsSwiperState] = useState({
        currSlide: 0,
        prevSlide: 0,
        touchedId: null,
        active: false,
    });

    useEffect(() => {
        const today = new Date();
        let initialIndex = selectedYear == today.getFullYear() ? today.getMonth() : 0;
        setDocumentsSwiperState({
            currSlide: initialIndex,
            prevSlide: initialIndex,
            touchedId: null,
            active: false,
        })
        setContractsSwiperState({
            currSlide: initialIndex,
            prevSlide: initialIndex,
            touchedId: null,
            active: false,
        })
    }, [selectedYear])

    const onContractSlideChange = (swiper, id) => {
        let index = swiper.activeIndex;
        if (contractsSwiperState.currSlide == index) return;

        setDocumentsSwiperState(prev => ({ ...prev, active: false }));
        setContractsSwiperState(prev => ({
            currSlide: index,
            prevSlide: prev.currSlide,
            touchedId: id,
            active: true,
        }));
    }

    const onDocumentSlideChange = (swiper, id) => {
        let index = swiper.activeIndex;
        if (documentsSwiperState.currSlide == index) return;

        setContractsSwiperState(prev => ({ ...prev, active: false }));
        setDocumentsSwiperState(prev => ({
            currSlide: index,
            prevSlide: prev.currSlide,
            touchedId: id,
            active: true,
        }));
    }

    return (
        <>
            <Grid item xs={12}>
                <h2>{selectedContractor.name}</h2>
                <div className='RepseStatusView-company-filters'>
                    <div style={{ marginRight: "auto" }}>
                        <ButtonAddHLPure
                            nameBtn={"Agregar contrato"}
                            onClickBtn={() => toggleContractDetailsScreen(true)}
                            iconAdd
                        />
                    </div>

                    <FilterHLPure
                        options={yearFilterOptions}
                        optionsValue={selectedYear.toString()}
                        nameOption="year"
                        valueItem="yearValue"
                        onFilterChange={onYearFilterChange} />
                </div>
            </Grid>
            <Grid item xs={12} className={`RepseGrid RepseStatusView-contracts-grid ${adjustScrollbar ? "adjust" : ""}`}>
                <GridSelectionHLPure
                    skip={0}
                    take={contractsDataGrid.length}
                    dataGrid={contractsDataGrid.map(item => item.id == selectedContract?.id ? { ...item, selected: true } : { ...item })}
                    onRowClick={onRowClickContract}
                    pageable={false}
                    resizable={true}
                    styleGrid={adjustScrollbar ? { maxHeight: '250px' } : null}

                    titleRow1={"Contrato"}
                    cellColumnOne={CellColumnOneContracts}
                    headerColumnOne={HeaderColumnOne}

                    columnTwo
                    titleRow2={showSwiper ? "" : "Acciones"}
                    cellColumnTwo={ActionsCell}
                    headerColumnTwo={HeaderActionsCol}
                    widthColumnTwo={showSwiper ? 55 : 125}

                    columnThree
                    titleRow3={""}
                    cellColumnThree={CellSemaforoContracts}
                    headerColumnThree={HeaderSemaforoContracts}
                />
            </Grid>
            {
                selectedContract &&
                <>
                    <Grid item xs={12} className='RepseStatusView-contract-name'>
                        <h3>Documentos del Contrato: {selectedContract.name}</h3>
                    </Grid>
                    <Grid item xs={12} className='RepseGrid'>
                        {
                            selectedContract &&
                            <GridSelectionHLPure
                                skip={0}
                                take={documentsDataGrid.length}
                                dataGrid={documentsDataGrid}
                                pageable={false}

                                titleRow1={"Documento"}
                                cellColumnOne={CellColumnOne}
                                headerColumnOne={HeaderColumnOne}

                                columnTwo
                                titleRow2={""}
                                cellColumnTwo={CellSemaforoDocuments}
                                headerColumnTwo={HeaderSemaforoDocuments}
                                // selectedHeader={onMonthSelected}
                                showBinnacle={showBinnacle}
                                onHeaderRowClick={onMonthSelected}
                                selectedContract={selectedContract}
                            />
                        }
                    </Grid>
                </>
            }
            {showBinnacle ? <RepseStatusByDocumentsView selectedContract={selectedContractor} selectedYear={selectedYear} month={selectedMonth} selectedMonthNumber={selectedMonthNumber} /> : null}
            <Grid xs={12} className='RepseStatusView-actions'>
                <ButtonHLPure
                    nameBtn={"Regresar"}
                    onClickBtn={onBack}
                />
            </Grid>
            {
                showDocumentDialog && documentUrl &&
                <Dialog title={selectedDocument.name} onClose={onCloseDialog} height={500} width={1000}>
                    <div className='RepseStatusView-document-dialog'>
                        {/* <div className='RepseStatusView-document-dialog-name'>
                            <p><span>Contrato:</span> {selectedContract.name}</p>
                            <p><span>Documento:</span> {selectedDocument.name}</p>
                        </div>
                        <div className='RepseStatusView-document-dialog-status'>
                            <p><span>Periodo:</span> {months[selectedMonth]} {selectedYear}</p>
                            <p><span>Estatus:</span> <span className={`status ${getColorByDocumentStatus(selectedDocument.compliance[selectedMonth])}`}></span> {selectedDocument.compliance[selectedMonth]}</p>
                        </div> */}
                        <div className='RepseStatusView-document-dialog-file'>
                            {pdfAws}
                        </div>
                    </div>
                </Dialog>
            }
        </>
    )
}

export default RepseStatusContractsView